import { render, staticRenderFns } from "./MyModule.vue?vue&type=template&id=a4c9c750&scoped=true"
import script from "./MyModule.vue?vue&type=script&lang=js"
export * from "./MyModule.vue?vue&type=script&lang=js"
import style0 from "./MyModule.vue?vue&type=style&index=0&id=a4c9c750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9c750",
  null
  
)

export default component.exports